<div class="p-2">
  <div class="font-semibold text-2xl mb-3" data-clarity-unmask="true">Transakcje</div>

  <div class="main-card p-3">
    <div
      class="flex w-full my-3 gap-3 flex-column justify-content-end align-items-end"
    >

      <div
        class="w-full md:w-20rem border-solid border-round-md border-1 p-1 border-300 flex justify-content-center align-items-center"
      >
        <i class="pi pi-search mr-2 cursor-pointer text-primary"></i>
        <input
          class="p-1 border-none outline-none text-base w-full"
          type="text"
          placeholder="Wyszukaj"
        />
      </div>
    </div>
    
    <fas-services-table
      [value]="oskList"
      [columns]="oskColumns"
      [rows]="10"
      [paginator]="false"
      [showCheckbox]="true"
      [(selection)]="oskSelected"
    [showFooterPageReport]="false"
    [footerButtonOptions]="oskFooterBtn"
    ></fas-services-table>

  </div>
</div>

